export default "__VITE_ASSET__DGsKXpGf__"